/** CSS animations and 3D portrait rotation use the same motion preference. */
export function reducedMotion(): boolean {
  return document.documentElement.dataset.reducedMotion === "true"
    || window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
